import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
  } from "react";
  
  /** Common Components */
  import MolGrid from "../../../../components/molGrid/MolGrid";
  
  /** Common Services & Data Files */
  import SwalAlert from "../../../../services/swalService/SwalService";
import { liabilityBasisTypeCombinationGridConfig } from "./liabilityBasisTypeCombinationList.grid.config";
import { useGetLiabilityTypesListMutation, useLazyGetLiabilityBasicTypeByIdQuery } from "../../../../app/services/liabilityTypesAPI";
import PropTypes from "prop-types";
  
  const LiabilityBasisTypeCombinationList = (props, ref) => {
    const molGridRef = useRef();
    const [dataSource, setDataSource] = useState([]);
    const [totalCount, setTotalCount] = useState([]);
    const [sortState, setSortState] = useState([]);


    const [getLiabilityTypes, {
      isLoading: isLiabilityListLoading,
      isSuccess: isGetLiabilityListSuccess,
      data: liabilityListData
    }] = useGetLiabilityTypesListMutation();

    const [getLiabilityBasicTypeListById, {
      isLoading: isLiabilityBasicTypeListFetching,
      isSuccess: isLiabilityBasicTypeListSuccess,
      data: liabilityBasicTypeListData
  }] = useLazyGetLiabilityBasicTypeByIdQuery();
  
    const { confirm } = SwalAlert();
  
    const getLiabilityTypesList = (pageObject) => {
      const req = {
        pagination: {
          pageNumber: pageObject.pageNumber,
          pageSize: pageObject.pageSize
        },
        filters: {
          searchText: ""
        },
      }
      getLiabilityTypes(req);
    }

    useEffect(() => {
      if (props?.listData?.length) {
        setDataSource(props.listData);
      }
    }, [props?.listData]);

    const sortData = (data, sortState) => {
      
      return [...data].sort((a, b) => {
          for (const sort of sortState) {
              const valA = a[sort.column] ?? '';
              const valB = b[sort.column] ?? '';
              const comparison = sort.direction === 'asc' 
                  ? valA.toString().localeCompare(valB.toString())
                  : valB.toString().localeCompare(valA.toString());
              if (comparison !== 0) return comparison;
          }
          return 0;
      });
  };
  
  const handleSortingChange = async(sortString,col) => {

    if (!sortString) return;    
    const newSortState = sortString
        .split(',')
        .map(item => {
            const [column, directionRaw] = item.trim().split(/\s+/); 
            const direction = directionRaw?.toLowerCase() === 'desc' ? 'desc' : 'asc';
            return { column, direction };
        })
        .filter(item => item.column); 
        const filtered = newSortState.filter(item => item.column === col.fieldName);
        setSortState(newSortState);
        const orderData = await sortData(dataSource,filtered);
        setDataSource(orderData);
};
    
    useEffect(() => {
      if (props.selectRow) {
        getLiabilityBasicTypeListById(props.selectRow);
      }
    }, [props.selectRow]);
        
    useEffect(() => {
      if (isGetLiabilityListSuccess && liabilityListData) {
        if (liabilityListData.dataSource) {
          setDataSource(liabilityListData.dataSource);
        }
        if (liabilityListData.totalRecord) {
          setTotalCount(liabilityListData.totalRecord);
        }
      }
    }, [isGetLiabilityListSuccess, liabilityListData]);

    useEffect(() => {
      if (isLiabilityBasicTypeListSuccess && liabilityBasicTypeListData) {
        props?.setListData(liabilityBasicTypeListData);
      }
    }, [isLiabilityBasicTypeListSuccess, liabilityBasicTypeListData]);
  
    useImperativeHandle(
      ref,
      () => ({
        refreshGrid: () => {
          if (ref.current) {
            getLiabilityTypesList(molGridRef.current.getDefaultPageObject());
          } else {
            return null;
          }
        },
      }),
      [ref]
    );
  
    return (
      <MolGrid
        ref={molGridRef}
        configuration={liabilityBasisTypeCombinationGridConfig}
        dataSource={dataSource}
        allowPagination={false}
        pagination={{
          totalCount: totalCount, 
          pageSize: 20,
          currentPage: 1,
        }}
         isLoading={isLiabilityBasicTypeListFetching}
         onSorting ={handleSortingChange}
      />
    );
  };
  
  LiabilityBasisTypeCombinationList.propTypes = {
    selectRow: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]), 
    listData: PropTypes.array,  
    setListData: PropTypes.func,
  };

  export default forwardRef(LiabilityBasisTypeCombinationList);
  